<template>
  <div class="d-flex justify-center flex-gap-8">
    <div>
      <span>{{ $t("quoteInfo.side") }}</span>
      <v-radio-group
        v-model="side"
        class="mt-0"
        @change="onSideChange"
        row
        mandatory
        :disabled="loadingNewRfq || gridActive"
      >
        <v-radio :label="$t('quoteInfo.buy').toUpperCase()" value="BUY">
        </v-radio>
        <v-radio :label="$t('quoteInfo.sell').toUpperCase()" value="SELL">
        </v-radio>
      </v-radio-group>
    </div>
    <div>
      <span>{{ $t("quoteInfo.ccy") }}</span>
      <v-radio-group
        v-model="ccy"
        class="mt-0"
        @change="onCurrencyChange"
        mandatory
        row
        :disabled="loadingNewRfq || gridActive"
      >
        <v-radio label="USD" value="USD"> </v-radio>
        <v-radio disabled label="EUR" value="EUR" class="disabled"> </v-radio>
      </v-radio-group>
    </div>
    <div>
      <span>{{ $t("quoteInfo.maturity") }}</span>
      <v-menu
        v-model="menu"
        :nudge-right="40"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="maturityDate"
            prepend-icon="mdi-calendar"
            readonly
            dense
            v-bind="attrs"
            v-on="on"
            style="width: 170px"
            hide-details
            class="mr-0 mr-sm-6 mb-2"
          >
          </v-text-field>
        </template>
        <v-date-picker
          @change="onMaturityDateChange"
          color="primary"
          :locale="locale"
          @input="menu = false"
          no-title
          :min="firstDate"
          v-model="maturityDate"
        >
        </v-date-picker>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  props: ["loadingNewRfq", "gridActive"],
  emits: ["ccy", "side", "maturityDate"],
  data() {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const isoTomorrow = new Date(
      tomorrow.getTime() - tomorrow.getTimezoneOffset() * 60000
    )
      .toISOString()
      .substring(0, 10);
    return {
      menu: false,
      side: undefined,
      ccy: undefined,
      settlement: undefined,
      maturityDate: isoTomorrow,
      firstDate: isoTomorrow,
    };
  },
  computed: {
    locale() {
      const savedLocale = localStorage.getItem("userLanguage");
      return savedLocale || "en";
    },
  },
  methods: {
    onMaturityDateChange(val) {
      this.$emit("maturityDate", val);
    },
    onSideChange(val) {
      this.$emit("side", val);
    },
    onCurrencyChange(val) {
      this.$emit("ccy", val);
    },
  },
};
</script>
